import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyukkinboListGetReq,
  TSyukkinboListGetRes,
  TSyukkinboGetReq,
  TZikanSyuseiPutReq,
  TZikanSyuseiListPutReq,
  TZyomuinSyukkinboDigitachoGetReq,
  TZyomuinSyukkinboDigitachoKintaiRes,
  TZyomuinSyukkinboYukyuByMonthGetRes,
  TSyukkinboDakokuGetRes,
} from "./TZyomuinSyukkinbo"

/**
 * 乗務員出勤簿に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class SyukkinboService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyukkinboListGetReq} params
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  zyomuinGetList = async (params: TSyukkinboListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyukkinboListGetRes[]>> =
        await this.getInner(`/attendance/zyomuinsyukkinbo/v2`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員有休数 取得
   *
   * @param {TSyukkinboGetReq} params
   * @param {(param: TApiResponse<TZyomuinSyukkinboYukyuByMonthGetRes>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinSyukkinboYukyuByMonthGetRes>) => any} reject
   * @memberof MenuService
   */
  zyomuinGetYukyuByMonthList = async (params: TSyukkinboGetReq) => {
    try {
      const res: AxiosResponse<
        TApiResponse<TZyomuinSyukkinboYukyuByMonthGetRes>
      > = await this.getInner(
        `/attendance/zyomuinsyukkinbo/v2/actions/getyukyubymonth`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 出勤簿 取得
   *
   * @param {TSyukkinboGetReq} params
   * @param {(param: TApiResponse<TSyukkinboIndividualGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyukkinboIndividualGetRes[]>) => any} reject
   * @memberof MenuService
   */
  zyomuinGetIndividualList = async (params: TSyukkinboGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyukkinboListGetRes>> =
        await this.getInner(
          `/attendance/zyomuinsyukkinbo/v2/actions/getindividuallist`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * デジタコ情報取得
   *
   * @param {TSyukkinboGetReq} params
   * @param {(param: TApiResponse<TZyomuinSyukkinboDigitachoKintaiRes[]>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinSyukkinboDigitachoKintaiRes[]>) => any} reject
   * @memberof MenuService
   */
  getDigiTachoList = async (params: TZyomuinSyukkinboDigitachoGetReq) => {
    try {
      const res: AxiosResponse<
        TApiResponse<TZyomuinSyukkinboDigitachoKintaiRes[]>
      > = await this.getInner(
        `/attendance/zyomuinsyukkinbo/v2/actions/getdigitacho`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TZikanSyuseiPutReq} data
   * @param {(param: TApiResponse<TZikanSyuseiGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZikanSyuseiGetRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (id: string, date: string, data: TZikanSyuseiPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `attendance/syukkinbo/${id}/${date}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 単体削除
   *
   * @param {TZikanSyuseiPutReq} data
   * @param {(param: TApiResponse<TZikanSyuseiGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZikanSyuseiGetRes>>) => any} reject
   * @memberof KyotenService
   */
  delete = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `attendance/zyomuinsyukkinbo/v2/actions/delete/${id}`,
        id
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * リスト更新
   *
   * @param {TZikanSyuseiPutReq} data
   * @param {(param: TApiResponse<TZikanSyuseiGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZikanSyuseiGetRes>>) => any} reject
   * @memberof KyotenService
   */
  putList = async (data: TZikanSyuseiListPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `attendance/zyomuinsyukkinbo/v2/upsertlist`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * リスト更新
   *
   * @param {TZikanSyuseiPutReq} data
   * @param {(param: TApiResponse<TZikanSyuseiGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZikanSyuseiGetRes>>) => any} reject
   * @memberof KyotenService
   */
  zyomuinPutList = async (data: TZikanSyuseiListPutReq) => {
    console.log(data)
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `attendance/zyomuinsyukkinbo/v2/upsertlist`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 打刻リスト取得
   *
   * @param {TSyukkinboListGetReq} params
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getDakokuList = async (params: TSyukkinboListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyukkinboDakokuGetRes[]>> =
        await this.getInner(
          `/attendance/syukkinbo/actions/getdakokulist`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 全て再作成
   *
   * @param {TSyukkinboListGetReq} params
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  reCreate = async () => {
    try {
      const res: AxiosResponse<boolean> = await this.postInner(
        `/attendance/zyomuinsyukkinbo/v2/recreate/zyomuinsyukkinbo`,
        {}
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
